export interface ITituloClienteSelecionado {
  titulo: string;
  codCliente?: string | null;
}

export interface ITitulosPorCliente {
  codCliente?: string | null;
  titulos: string;
}

export abstract class FinancialInformationHelper {
  static agruparTitulosPorCliente(itens: ITituloClienteSelecionado[]): ITitulosPorCliente[] {
    const grupos = new Map<string, { codCliente?: string | null; titulos: string[] }>();

    itens.forEach((item) => {
      const chave = item.codCliente || '';
      const grupo = grupos.get(chave);
      if (grupo) {
        grupo.titulos.push(item.titulo);
      } else {
        grupos.set(chave, { codCliente: item.codCliente, titulos: [item.titulo] });
      }
    });

    return Array.from(grupos.values()).map((grupo) => ({
      codCliente: grupo.codCliente,
      titulos: grupo.titulos.join(','),
    }));
  }
}
